import should from 'should';

export default should;
